import { useFindAllContactSentiments } from 'hooks/contact-sentiments';
import { usePaging } from 'hooks/usePaging';
import { useGetContactsQuery } from 'services/contacts/contacts.api';
import { FindAllContactSentimentsDto } from 'types';
import { ContactDto, FindAllContactsDto } from 'types/dto/contacts';

const pageSize = 7;
export function useContactsPaging(params: Omit<FindAllContactsDto, 'pageIndex' | 'pageSize'>, isHasSentiments = true) {
  const { name, address, phoneNumber, ticketId, customerCode, wardId, districtId } = params;

  const { pageIndex, changePage, resetPage } = usePaging(params);

  const shouldFetch = !!(name || address || phoneNumber || ticketId || customerCode || wardId || districtId);

  const queryParams = shouldFetch
    ? {
        pageIndex,
        pageSize,
        name,
        address,
        phoneNumber,
        ticketId,
        customerCode,
        wardId,
        districtId
      }
    : {
        pageIndex,
        pageSize,
        name: '',
        address: '',
        phoneNumber: '',
        ticketId: undefined,
        customerCode: '',
        wardId: undefined,
        districtId: undefined
      };

  const {
    data: contactsResponse,
    error,
    isFetching,
    isLoading
  } = useGetContactsQuery(queryParams, {
    skip: !shouldFetch
  });

  const handleChangePage = changePage;

  const contacts = shouldFetch ? contactsResponse?.data.rows || [] : [];

  const contactSentimentsFind: FindAllContactSentimentsDto = {
    filters: contacts.map((contact) => ({
      idNumber: contact.idNumber,
      phoneNumber: contact.phoneNumber
    }))
  };

  const { contactSentiments, isFetchingContactSentiments, isLoadingContactSentiments, refetchContactSentiments } =
    useFindAllContactSentiments(contactSentimentsFind, {
      skip: contacts.length === 0 || !isHasSentiments
    });

  return {
    contacts: isHasSentiments
      ? (contacts.map((contact) => {
          const sentiment = contactSentiments?.find(
            (sentiment) =>
              sentiment.phoneNumber === contact.phoneNumber &&
              (!contact.idNumber || sentiment.idNumber === contact.idNumber)
          );
          return {
            ...contact,
            contactSentiment: sentiment || null
          };
        }) as ContactDto[])
      : contacts,
    count: shouldFetch ? contactsResponse?.data.count || 0 : 0,
    isLoading: shouldFetch && (isFetching || isLoading),
    pageIndex,
    pageSize,
    handleChangePage,
    resetPage,
    error,

    contactSentiments,
    isLoadingContactSentiments,
    isFetchingContactSentiments,
    refetchContactSentiments
  };
}
